/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Import Icon component.
 */
export const ImportIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_20017)'>
        <path d='M32.25 16.7337C31.1167 10.9837 26.0667 6.66699 20 6.66699C15.1833 6.66699 11 9.40033 8.91667 13.4003C3.9 13.9337 0 18.1837 0 23.3337C0 28.8503 4.48333 33.3337 10 33.3337H31.6667C36.2667 33.3337 40 29.6003 40 25.0003C40 20.6003 36.5833 17.0337 32.25 16.7337ZM31.6667 30.0003H10C6.31667 30.0003 3.33333 27.017 3.33333 23.3337C3.33333 19.917 5.88333 17.067 9.26667 16.717L11.05 16.5337L11.8833 14.9503C13.4667 11.9003 16.5667 10.0003 20 10.0003C24.3667 10.0003 28.1333 13.1003 28.9833 17.3837L29.4833 19.8837L32.0333 20.067C34.6333 20.2337 36.6667 22.417 36.6667 25.0003C36.6667 27.7503 34.4167 30.0003 31.6667 30.0003ZM13.3333 21.667H17.5833V26.667H22.4167V21.667H26.6667L20 15.0003L13.3333 21.667Z' fill={iconColor} />
      </g>
      <defs>
        <clipPath id='clip0_14304_20017'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ImportIcon;
